import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { AuthShell } from "@/pages/Login";
import { RolePicker } from "@/pages/Register";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/lib/i18n";
import { api, errMsg, dashboardPath } from "@/lib/api";
import { toast } from "sonner";

export default function ChooseRole() {
  const { t } = useLang();
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [role, setRole] = useState("tenant");
  if (user === false) return <Navigate to="/login" replace />;
  const save = async () => {
    try {
      const { data } = await api.put("/auth/profile", { role });
      setUser(data);
      nav(dashboardPath(data));
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <AuthShell title={t("choose_role_title")} sub={t("choose_role_sub")} testid="choose-role-page">
      <RolePicker value={role} onChange={setRole} />
      <button onClick={save} className="mt-6 h-12 w-full rounded-full bg-[#FF6B00] font-bold text-white hover:bg-[#E05A00]" data-testid="choose-role-submit-btn">{t("continue")}</button>
    </AuthShell>
  );
}
